import BaseController from "confinus_ui/base_controller";

const ACTIVE_CLASSES = ["px-[13px]", "py-1", "bg-error", "text-white"];
const MINUTES_BEFORE_RUN = 30;
const SECONDS_BEFORE_RUN = MINUTES_BEFORE_RUN * 60;

export default class DeliveryCutOffPillController extends BaseController {
  public static values = {
    timeToCutOff: Number,
  };

  declare private readonly timeToCutOffValue: number;
  private activateTimerId: any = null;
  private inactivateTimerId: any = null;

  public connect() {
    super.connect();
    const timeToCutOff = this.timeToCutOffValue;
    if (timeToCutOff !== null && timeToCutOff > 0) {
      const timeToActivateElement = timeToCutOff - SECONDS_BEFORE_RUN;
      this.activateTimerId = this.activateElement(
        this.calculateTimeout(timeToActivateElement),
      );
      this.inactivateTimerId = this.deactivateElement(
        this.calculateTimeout(timeToCutOff),
      );
    }
  }

  public disconnect() {
    if (this.activateTimerId !== null) {
      clearTimeout(this.activateTimerId);
      this.activateTimerId = null;
    }
    if (this.inactivateTimerId !== null) {
      clearTimeout(this.inactivateTimerId);
      this.inactivateTimerId = null;
    }
    super.disconnect();
  }

  public activateElement = (timeout: number) => {
    let timerId: any;
    if (timeout > 0) {
      timerId = setTimeout(this.addActiveClass, timeout);
    } else {
      this.addActiveClass();
    }
    return timerId || null;
  };

  public deactivateElement = (timeout: number) => {
    let timerId: any;
    if (timeout > 0) {
      timerId = setTimeout(this.removeActiveClass, timeout);
    }
    return timerId;
  };

  public calculateTimeout(timeoutInSeconds: number) {
    return timeoutInSeconds * 1000;
  }

  public addActiveClass = () => {
    this.element.classList.add(...ACTIVE_CLASSES);
  };

  public removeActiveClass = () => {
    this.element.classList.remove(...ACTIVE_CLASSES);
  };
}
